module.exports = process.env.npm_package_version;
